import React, { useContext } from 'react';
import { StyledShowBookmarksSidebarButton } from './show-bookmarks-sidebar-button.styles';
import { Context } from '../../../store/store';

const ShowBookmarksSidebarButton = () => {
  const [, dispatch] = useContext(Context);
  const handleClick = () => {
    dispatch({ type: 'TOGGLE_BOOKMARKS_SIDEBAR' });
  };

  return (
    <StyledShowBookmarksSidebarButton onClick={handleClick}>
      Закладки
    </StyledShowBookmarksSidebarButton>
  );
};

export default ShowBookmarksSidebarButton;
